import { render, staticRenderFns } from "./course-button.vue?vue&type=template&id=94e1deaa&"
import script from "./course-button.vue?vue&type=script&lang=js&"
export * from "./course-button.vue?vue&type=script&lang=js&"
import style0 from "./course-button.vue?vue&type=style&index=0&id=94e1deaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports